/**
 * Idempotency guard for OAuth redirect handling
 *
 * Prevents double redemption of authorization codes when React StrictMode
 * causes components to mount twice.
 *
 * Uses sessionStorage for per-tab isolation (cleared on tab close).
 */

const REDIRECT_HANDLED_KEY = 'msal.redirect.handled';

/**
 * Check if the OAuth redirect has already been handled in this session
 * @returns true if redirect was already processed, false otherwise
 */
export function isRedirectHandled(): boolean {
  try {
    return sessionStorage.getItem(REDIRECT_HANDLED_KEY) === 'true';
  } catch (error) {
    console.warn('Failed to check redirect status:', error);
    return false;
  }
}

/**
 * Mark the OAuth redirect as successfully handled
 */
export function markRedirectAsHandled(): void {
  try {
    sessionStorage.setItem(REDIRECT_HANDLED_KEY, 'true');
  } catch (error) {
    console.warn('Failed to mark redirect as handled:', error);
  }
}

/**
 * Clear the redirect handled flag
 * Should be called on explicit logout to allow fresh login flow
 */
export function clearRedirectHandled(): void {
  try {
    sessionStorage.removeItem(REDIRECT_HANDLED_KEY);
  } catch (error) {
    console.warn('Failed to clear redirect status:', error);
  }
}
